var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.$style.container },
    [
      _c(
        "div",
        { class: _vm.$style.image },
        [
          _c("NsImage", {
            attrs: {
              src: _vm.imageUrl,
              "maintain-ratio": "4x3",
              "image-fit": _vm.imageFit
            }
          }),
          _vm._v(" "),
          _vm.isVideo
            ? _c(
                "div",
                {
                  class: _vm.$style.videoBtn,
                  on: { click: _vm.handleOpenLightbox }
                },
                [
                  _c("NsIcon", {
                    class: _vm.$style.videoIcon,
                    attrs: { size: "custom", "icon-name": "icon-play-outline" }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.title
        ? _c("div", {
            class: _vm.$style.title,
            domProps: { innerHTML: _vm._s(_vm.title) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.contentText
        ? _c("div", {
            class: _vm.$style.contentText,
            domProps: { innerHTML: _vm._s(_vm.contentText) }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.linkUrl && _vm.linkText
        ? _c(
            "div",
            { class: _vm.$style.link },
            [
              _vm.phabletAndDown
                ? _c(
                    "a",
                    {
                      staticClass: "primary-ghost fluid",
                      attrs: { href: _vm.linkUrl }
                    },
                    [_vm._v("\n      " + _vm._s(_vm.linkText) + "\n    ")]
                  )
                : _c("NsExpressiveLink", { attrs: { href: _vm.linkUrl } }, [
                    _vm._v(_vm._s(_vm.linkText))
                  ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isVideo
        ? _c("NsLightbox", {
            attrs: {
              open: _vm.lightboxOpen,
              "video-src": _vm.videoSrc,
              "video-src-tags": _vm.videoSrcTags
            },
            on: { close: _vm.handleCloseLightbox }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }